(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-sa-scratch-popup]';
  var DISMISSED_KEY = 'sa_camigoo_scratch_dismissed_v1';
  var CLAIMED_KEY = 'sa_camigoo_scratch_claimed_v1';

  function initScratchPopup(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var dialog = root.querySelector('.sa-scratch-popup__dialog');
    var canvas = root.querySelector('[data-sa-scratch-canvas]');
    var card = root.querySelector('[data-sa-scratch-card]');
    var claimButton = root.querySelector('[data-sa-scratch-claim]');
    var revealButton = root.querySelector('[data-sa-scratch-reveal]');
    var hint = root.querySelector('[data-sa-scratch-hint]');
    var form = root.querySelector('[data-sa-scratch-form]');
    var errorBox = root.querySelector('[data-sa-scratch-error]');
    var submitButton = root.querySelector('[data-sa-scratch-submit]');
    var closeButtons = root.querySelectorAll('[data-sa-scratch-close]');
    var stages = root.querySelectorAll('[data-sa-scratch-stage]');
    var previouslyFocused = null;
    var isOpen = false;
    var revealed = false;
    var drawing = false;
    var lastPoint = null;
    var moveCount = 0;

    var delayMs = Number(root.dataset.delayMs || 6000);
    var repeatDays = Number(root.dataset.repeatDays || 14);
    var claimedDays = Number(root.dataset.claimedDays || 90);
    var designMode = root.dataset.designMode === 'true' || Boolean(window.Shopify && Shopify.designMode);
    var params = new URLSearchParams(window.location.search);
    var forcePreview = params.get('sa_scratch_preview') === '1' || designMode;

    function storedWithin(key, days) {
      try {
        var timestamp = Number(window.localStorage.getItem(key));
        return timestamp > 0 && Date.now() - timestamp < days * 86400000;
      } catch (error) {
        return false;
      }
    }

    function remember(key) {
      try {
        window.localStorage.setItem(key, String(Date.now()));
      } catch (error) {
        // Storage can be unavailable in private browsing; the popup still works.
      }
    }

    function showStage(name) {
      stages.forEach(function (stage) {
        stage.hidden = stage.dataset.saScratchStage !== name;
      });
    }

    function openPopup() {
      if (isOpen) return;
      isOpen = true;
      previouslyFocused = document.activeElement;
      root.hidden = false;
      document.body.classList.add('sa-scratch-lock');
      window.requestAnimationFrame(function () {
        setupCanvas();
        var close = root.querySelector('.sa-scratch-popup__close');
        if (close) close.focus({ preventScroll: true });
      });
    }

    function closePopup() {
      if (!isOpen) return;
      isOpen = false;
      root.hidden = true;
      document.body.classList.remove('sa-scratch-lock');
      if (!storedWithin(CLAIMED_KEY, claimedDays)) remember(DISMISSED_KEY);
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus({ preventScroll: true });
      }
    }

    function revealPrize() {
      if (revealed) return;
      revealed = true;
      canvas.classList.add('is-revealed');
      claimButton.hidden = false;
      revealButton.hidden = true;
      if (hint) hint.textContent = 'Je hebt 10% korting gewonnen.';
      claimButton.focus({ preventScroll: true });
    }

    function drawCover(context, width, height, ratio) {
      context.save();
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
      var gradient = context.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#d7dce0');
      gradient.addColorStop(0.48, '#aeb8bf');
      gradient.addColorStop(1, '#dfe3e6');
      context.fillStyle = gradient;
      context.fillRect(0, 0, width, height);

      context.globalAlpha = 0.22;
      context.strokeStyle = '#ffffff';
      context.lineWidth = 2;
      for (var x = -height; x < width + height; x += 20) {
        context.beginPath();
        context.moveTo(x, 0);
        context.lineTo(x + height, height);
        context.stroke();
      }

      context.globalAlpha = 1;
      context.fillStyle = '#34495a';
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.font = '700 18px Arial, sans-serif';
      context.fillText('KRAS HIER', width / 2, height / 2 - 8);
      context.font = '500 12px Arial, sans-serif';
      context.fillText('en ontdek je voordeel', width / 2, height / 2 + 18);
      context.restore();
    }

    function setupCanvas() {
      if (!canvas || !card || revealed) return;
      var rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(rect.width * ratio);
      canvas.height = Math.round(rect.height * ratio);
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      var context = canvas.getContext('2d', { willReadFrequently: true });
      context.globalCompositeOperation = 'source-over';
      drawCover(context, rect.width, rect.height, ratio);
      canvas.dataset.ratio = String(ratio);
    }

    function pointFromEvent(event) {
      var rect = canvas.getBoundingClientRect();
      var ratio = Number(canvas.dataset.ratio || 1);
      return { x: (event.clientX - rect.left) * ratio, y: (event.clientY - rect.top) * ratio };
    }

    function eraseTo(point) {
      var context = canvas.getContext('2d', { willReadFrequently: true });
      var ratio = Number(canvas.dataset.ratio || 1);
      context.save();
      context.globalCompositeOperation = 'destination-out';
      context.lineCap = 'round';
      context.lineJoin = 'round';
      context.lineWidth = 38 * ratio;
      context.beginPath();
      if (lastPoint) context.moveTo(lastPoint.x, lastPoint.y);
      else context.moveTo(point.x, point.y);
      context.lineTo(point.x, point.y);
      context.stroke();
      context.restore();
      lastPoint = point;
    }

    function scratchedEnough() {
      var context = canvas.getContext('2d', { willReadFrequently: true });
      var pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
      var transparent = 0;
      var samples = 0;
      var step = 4 * 14;
      for (var index = 3; index < pixels.length; index += step) {
        samples += 1;
        if (pixels[index] < 24) transparent += 1;
      }
      return samples > 0 && transparent / samples >= 0.42;
    }

    function handlePointerDown(event) {
      if (revealed) return;
      drawing = true;
      lastPoint = pointFromEvent(event);
      if (canvas.setPointerCapture) canvas.setPointerCapture(event.pointerId);
      eraseTo(lastPoint);
      event.preventDefault();
    }

    function handlePointerMove(event) {
      if (!drawing || revealed) return;
      eraseTo(pointFromEvent(event));
      moveCount += 1;
      if (moveCount % 10 === 0 && scratchedEnough()) revealPrize();
      event.preventDefault();
    }

    function handlePointerEnd() {
      if (!drawing) return;
      drawing = false;
      lastPoint = null;
      if (!revealed && scratchedEnough()) revealPrize();
    }

    function showError(message) {
      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    function clearError() {
      errorBox.textContent = '';
      errorBox.hidden = true;
    }

    function validEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function subscribe(email) {
      var companyId = root.dataset.klaviyoCompanyId;
      var listId = root.dataset.klaviyoListId;
      if (!companyId || !listId || listId.indexOf('PENDING_') === 0) {
        return Promise.reject(new Error('The Klaviyo list is not configured.'));
      }

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Camigoo kraskaart 10%',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  locale: document.documentElement.lang || 'nl-NL',
                  properties: {
                    'Kraskaart voordeel': '10%',
                    'Kraskaart pagina': window.location.pathname,
                    'Kraskaart geclaimd op': new Date().toISOString()
                  },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };

      return window.fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2026-07-15'
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (!response.ok) throw new Error('Klaviyo subscription failed: ' + response.status);
        return response;
      });
    }

    function handleSubmit(event) {
      event.preventDefault();
      clearError();
      var emailInput = form.elements.email;
      var consentInput = form.elements.marketing_consent;
      var email = String(emailInput.value || '').trim().toLowerCase();

      if (!validEmail(email)) {
        showError('Vul een geldig e-mailadres in.');
        emailInput.focus();
        return;
      }
      if (!consentInput.checked) {
        showError('Vink aan dat we je de kortingscode per e-mail mogen sturen.');
        consentInput.focus();
        return;
      }

      submitButton.disabled = true;
      submitButton.textContent = 'Even geduld…';

      subscribe(email)
        .then(function () {
          remember(CLAIMED_KEY);
          if (window.klaviyo && typeof window.klaviyo.push === 'function') {
            window.klaviyo.push(['identify', { email: email }]);
            window.klaviyo.push(['track', 'Camigoo Scratch Offer Claimed', { offer: '10%', page: window.location.pathname }]);
          }
          showStage('success');
        })
        .catch(function () {
          showError('Dat ging niet goed. Probeer het opnieuw of neem contact met ons op.');
        })
        .finally(function () {
          submitButton.disabled = false;
          submitButton.textContent = 'Stuur mijn kortingscode';
        });
    }

    function handleKeydown(event) {
      if (!isOpen) return;
      if (event.key === 'Escape') {
        closePopup();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(
        dialog.querySelectorAll('button:not([hidden]):not([disabled]), a[href], input:not([disabled])')
      ).filter(function (element) { return element.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    closeButtons.forEach(function (button) { button.addEventListener('click', closePopup); });
    canvas.addEventListener('pointerdown', handlePointerDown);
    canvas.addEventListener('pointermove', handlePointerMove);
    canvas.addEventListener('pointerup', handlePointerEnd);
    canvas.addEventListener('pointercancel', handlePointerEnd);
    canvas.addEventListener('pointerleave', handlePointerEnd);
    revealButton.addEventListener('click', revealPrize);
    claimButton.addEventListener('click', function () {
      showStage('email');
      var email = form.elements.email;
      if (email) window.setTimeout(function () { email.focus(); }, 60);
    });
    form.addEventListener('submit', handleSubmit);
    document.addEventListener('keydown', handleKeydown);

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        if (isOpen && !revealed && !drawing) setupCanvas();
      }).observe(card);
    } else {
      window.addEventListener('resize', function () {
        if (isOpen && !revealed && !drawing) setupCanvas();
      });
    }

    var configuredListId = root.dataset.klaviyoListId || '';
    var configurationReady = configuredListId && configuredListId.indexOf('PENDING_') !== 0;
    if (!configurationReady && !forcePreview) return;

    var shouldSuppress = storedWithin(CLAIMED_KEY, claimedDays) || storedWithin(DISMISSED_KEY, repeatDays);
    if (forcePreview || !shouldSuppress) {
      window.setTimeout(openPopup, forcePreview ? 250 : Math.max(delayMs, 0));
    }
  }

  function boot() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initScratchPopup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();